"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const schemas_1 = require("../schemas");
const getSize = (size) => ((0, elements_ui_utils_1.classNames)(schemas_1.widthSizesSchema[size], schemas_1.heightSizesSchema[size]));
const SkeletonCircle = (props) => {
    const sizeClass = (props.size && getSize(props.size)) || getSize(20);
    return (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)('rounded-full bg-misc-200 animate-pulse', sizeClass, props.className || '') }));
};
exports.default = SkeletonCircle;
//# sourceMappingURL=SkeletonCircle.js.map